module.exports = __webpack_public_path__ + "static/media/paper4.397ccb2a.png";